module.exports = __webpack_public_path__ + "ff47dfb13c2042c02c99a38ba0ce6fec.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-goodshare/src/fonts/fontello.eot?88483298
// module id = 7
// module chunks = 0